export default __webpack_public_path__ + "static/video-a5372be24f250159af9fe02ac2fc1d18.png";